import styled from 'styled-components'

import { Checkbox } from 'common-components'

export const Component = styled(Checkbox)`
  color: inherit !important;
`

const HookComponent = (hoc) => {
  const WrappedInput = hoc ? hoc(Component) : Component
  return function(props) {
    const { setValue, dispatch, onChange = () => {}, value, validate } = props
    const _onChange = (e) => {
      console.log(`Checkbox Value e.target.checked :`, value)
      setValue(!value)
      onChange({ dispatch, value: value })
    }
    const handleFocus = () => {
      if (validate) validate(false)
    }

    const handleBlur = () => {
      if (validate) validate(true)
    }
    return (
      <WrappedInput
        {...props}
        value={value}
        onChange={_onChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        checked={value}
      />
    )
  }
}

export default HookComponent
